import { updateFingeringLabelContent } from './updateFingeringLabelContent';
import type { ScoreSystemData } from './swapPdfFingeringData';

/**
 * Update SVG text elements after swapping fingerings for PDF project page
 * @param scoreSystems - The updated score system data with swapped fingerings
 * @param groupsToSwap - Array of {imageIndex, groupIndex} that were swapped
 */
export const updatePdfFingeringSvg = (
  scoreSystems: ScoreSystemData[],
  groupsToSwap: Array<{ imageIndex: number; groupIndex: number }>
): void => {
  groupsToSwap.forEach((group) => {
    const overlayContainer = document.getElementById(
      `fingering-overlay-${group.imageIndex}`
    );
    if (!overlayContainer) {
      console.warn(`Overlay container not found for image ${group.imageIndex}`);
      return;
    }

    // Find the SVG element
    const svg = overlayContainer.querySelector('svg');
    if (!svg) {
      console.warn(`SVG not found for image ${group.imageIndex}`);
      return;
    }

    // Find all g elements (fingering groups) and get the one at groupIndex
    const gElements = svg.querySelectorAll('g[data-direction]');
    const targetGroup = gElements[group.groupIndex];
    if (!targetGroup) {
      console.warn(
        `Target group not found at index ${group.groupIndex} in image ${group.imageIndex}`
      );
      return;
    }

    // Get all text elements in this group
    const textElements = targetGroup.querySelectorAll('text');
    const fingeringData =
      scoreSystems[group.imageIndex].fingeringGroupList[group.groupIndex];

    // Separate main and alt fingerings from the swapped data
    const mainFingerings = fingeringData.fingeringNumList
      .filter((fn) => fn.mainFingering > 0)
      .map((fn) => fn.mainFingering);
    const altFingerings = fingeringData.fingeringNumList
      .filter((fn) => fn.altFingering > 0)
      .map((fn) => fn.altFingering);

    // Update text content for main fingerings
    mainFingerings.forEach((value, idx) => {
      if (textElements[idx]) {
        updateFingeringLabelContent(textElements[idx], value.toString());
      }
    });

    // Update text content for alt fingerings
    altFingerings.forEach((value, idx) => {
      const textIdx = mainFingerings.length + idx;
      if (textElements[textIdx]) {
        updateFingeringLabelContent(textElements[textIdx], value.toString());
      }
    });
  });
};
